import { OneDriveText } from 'owa-locstrings/lib/strings/onedrivetext.locstring.json';
import { ViewInText } from './getDataProviderInfo.locstring.json';
import loc, { format } from 'owa-localize';
import truncateUrlForItemLocation from './truncateUrlForItemLocation';
import { assertNever } from 'owa-assert';
import createDataProviderInfoMapping from 'owa-attachment-model-store/lib/utils/DataProviderInfo/createDataProviderInfoMapping';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';

export interface AttachmentDataProviderInfo {
    viewInProviderOptionText: string;
    GetUrlForViewInProviderAction: (originalUrl: string) => string;
}

function createDefaultAttachmentDataProviderInfo(): AttachmentDataProviderInfo {
    return {
        viewInProviderOptionText: null,
        GetUrlForViewInProviderAction: (originalUrl: string) => originalUrl,
    };
}

function getViewInTextForOneDrive(): string {
    return format(loc(ViewInText), loc(OneDriveText));
}

function createDataProviderOneDriveProInfo(): AttachmentDataProviderInfo {
    const defaultInfo = createDefaultAttachmentDataProviderInfo();
    return {
        ...defaultInfo,
        viewInProviderOptionText: getViewInTextForOneDrive(),
        GetUrlForViewInProviderAction: (originalUrl: string) =>
            truncateUrlForItemLocation(originalUrl),
    };
}

function createDataProviderOneDriveConsumerInfo(): AttachmentDataProviderInfo {
    const defaultInfo = createDefaultAttachmentDataProviderInfo();
    return {
        ...defaultInfo,
        viewInProviderOptionText: getViewInTextForOneDrive(),
    };
}

function createDataProviderInfo(
    providerType: AttachmentDataProviderType
): AttachmentDataProviderInfo {
    switch (providerType) {
        case AttachmentDataProviderType.OneDrivePro:
            return createDataProviderOneDriveProInfo();
        case AttachmentDataProviderType.OneDriveConsumer:
            return createDataProviderOneDriveConsumerInfo();
        case AttachmentDataProviderType.Dropbox:
        case AttachmentDataProviderType.Box:
        case AttachmentDataProviderType.GDrive:
        case AttachmentDataProviderType.WopiBox:
        case AttachmentDataProviderType.WopiEgnyte:
        case AttachmentDataProviderType.WopiDropbox:
            return createDefaultAttachmentDataProviderInfo();
        case AttachmentDataProviderType.Facebook:
        case AttachmentDataProviderType.Mailbox:
        case AttachmentDataProviderType.MailMessage:
            return null;
        default:
            return assertNever(providerType);
    }
}

const { getDataProviderInfo, getDefaultDataProviderInfo } = createDataProviderInfoMapping<
    AttachmentDataProviderInfo
>(createDataProviderInfo);

export default getDataProviderInfo;
export { getDefaultDataProviderInfo };
